import React, { useMemo } from "react";
import { Html } from "@react-three/drei";
import { useModelStore } from "../../../../store/useModelStore";
import { useUIStore } from "../../../../store/useUIStore";
import { getScaleFromRange, scaleToGrid } from "@/utils/gridScale";

export const SelectedNodeIDLabels: React.FC = () => {
  const nodes = useModelStore((state) => state.nodes);
  const selectedNodeIds = useModelStore((state) => state.selectedNodeIds);
  const showNodeIds = useUIStore((state) => state.showNodeIds);
  const scaleRange = useUIStore((state) => state.scaleRange);

  const scaleFactor = getScaleFromRange(scaleRange);

  const scaledNodes = useMemo(() => {
    return nodes.map((node) => ({
      ...node,
      x: scaleToGrid(node.x, scaleFactor),
      y: scaleToGrid(node.y, scaleFactor),
      z: scaleToGrid(node.z, scaleFactor),
    }));
  }, [nodes, scaleFactor]);

  if (showNodeIds) return null;
  if (!selectedNodeIds?.length || !nodes?.length) return null;

  const selectedNodes = scaledNodes.filter((node) =>
    selectedNodeIds.includes(node.id)
  );

  return (
    <>
      {selectedNodes.map((node) => (
        <Html
          key={`selected-node-label-${node.id}`}
          position={[node.x, node.y + 1.2, node.z]}
          center
          zIndexRange={[0, 10]}
        >
          <div
            style={{
              pointerEvents: "none",
              userSelect: "none",
              fontFamily:
                "Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica Neue, Arial",
              fontSize: "16px",
              fontWeight: 600,
              color: "#1e40af",
              textShadow: "0 0 2px white, 0 0 4px white",
              whiteSpace: "nowrap",
            }}
          >
            N{node.id}
          </div>
        </Html>
      ))}
    </>
  );
};
